import { render, staticRenderFns } from "./MySeek.vue?vue&type=template&id=71ef0d98&"
import script from "./MySeek.vue?vue&type=script&lang=ts&"
export * from "./MySeek.vue?vue&type=script&lang=ts&"
import style0 from "./MySeek.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports